import { plural, t } from "@lingui/core/macro";
import React, { useCallback } from "react";
import RefinedListDropdown, {
  DynamicTitleFunction
} from "../RefinementListFilter/RefinedListDropdown";
import RefinedList from "../RefinementListFilter/RefinedList";
import { FycCruisesTagCategoryContentFragment } from "types/graphql-types";
import { cruisesLabel } from "src/utils/cruise";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { useLanguage } from "src/utils/localization/languages/I18nContext";

type Props = {
  cruisesTagCategoryContent: FycCruisesTagCategoryContentFragment[];
};

const nameForItem =
  (content: FycCruisesTagCategoryContentFragment[]) =>
  (items: RefinementListItem[]): RefinementListItem[] => {
    const transformedItems = [...items]
      .map((item) => {
        const cruiseTag = content?.find(
          (s) => s.title?.localized?.trim() == item.value.trim()
        );
        const label = cruiseTag?.title?.localized?.trim();
        if (!label) return item;

        return {
          ...item,
          label
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
    return transformedItems;
  };

const buildDynamicTitle: DynamicTitleFunction = (count) =>
  count > 0
    ? plural(count, {
        one: "# cruise event selected",
        other: "# cruise events selected"
      })
    : t`Select Events & Themes`;

export const CruiseTagFilterDropDown: React.FC<Props> = ({
  cruisesTagCategoryContent
}) => {
  const language = useLanguage();
  const transformItems = useCallback(nameForItem(cruisesTagCategoryContent), [
    cruisesTagCategoryContent
  ]);
  return (
    <RefinedListDropdown
      dynamicTitle={buildDynamicTitle}
      label={t`Cruise Events & Themes`}
      dataContentPiece="cruise_tag_filter_interaction"
      attribute={`cruiseTagsTree.${language.sanityCode}.level0`}
      operator="or"
      transformItems={transformItems}
      limit={100}
      counterLabel={cruisesLabel}
    />
  );
};

export const CruiseTagFilterList: React.FC<Props> = ({
  cruisesTagCategoryContent
}) => {
  const language = useLanguage();
  const transformItems = useCallback(nameForItem(cruisesTagCategoryContent), [
    cruisesTagCategoryContent
  ]);

  return (
    <RefinedList
      title={buildDynamicTitle}
      dataContentName="cruise_tag_filter_interaction"
      attribute={`cruiseTagsTree.${language.sanityCode}.level0`}
      operator="or"
      transformItems={transformItems}
      limit={100}
    />
  );
};
